export const navLinks = [
  { id: "about", label: "회생센터" },
  { id: "field", label: "상담분야" },
  { id: "compare", label: "제도비교" },
  { id: "process", label: "진행절차" },
  { id: "success", label: "성공사례" },
  { id: "faq", label: "FAQ" },
  { id: "diagnosis", label: "자가진단" },
];

export const heroStats = [
  { value: "무료상담", label: "첫 상담 비용 없음" },
  { value: "1:1 집중", label: "전담 변호사 직접" },
  { value: "비밀보장", label: "상담 내용 철저 보호" },
];

export const aboutStats = [
  { value: "1,500+", label: "누적 상담" },
  { value: "1:1", label: "직접 상담" },
  { value: "12년+", label: "도산 실무" },
];

export const practiceFields = [
  {
    no: "01",
    title: "개인회생",
    desc: "일정한 소득이 있는 분이 3~5년간 변제 후 남은 채무를 면책받는 절차. 압류·추심을 멈추고 재기의 발판을 마련합니다.",
    points: ["압류·추심 중단", "감당 가능한 변제안 설계", "인가 후 잔여 채무 면책"],
    icon: "ri-refresh-line",
  },
  {
    no: "02",
    title: "개인파산",
    desc: "소득으로 상환이 불가능한 분이 재산을 정리하고 채무를 면책받는 절차. 무소득·고령 등 회생이 어려운 경우 적합합니다.",
    points: ["재산 정리·면책", "무소득·고령자 적합", "채무의 굴레에서 해방"],
    icon: "ri-shield-check-line",
  },
  {
    no: "03",
    title: "채무조정 · 기타",
    desc: "개인회생·파산 외에도 상황에 맞는 채무조정 방향을 함께 검토합니다. 워크아웃·신복위 등도 안내해 드립니다.",
    points: ["워크아웃 검토", "신복위 채무조정", "최적 제도 비교 진단"],
    icon: "ri-scales-3-line",
  },
];

export const compareRows = [
  { label: "대상", rehab: "지속적인 소득이 있는 분", bankrupt: "소득으로 상환이 불가능한 분" },
  { label: "핵심", rehab: "3~5년 변제 후 잔여 채무 면책", bankrupt: "재산 정리 후 전체 채무 면책" },
  { label: "재산", rehab: "원칙적으로 보유·유지 가능", bankrupt: "일정 재산은 환가·배당" },
  { label: "기간", rehab: "통상 4~6개월 내 인가", bankrupt: "통상 6개월~1년 내 면책" },
  { label: "효과", rehab: "압류·추심 중지, 재기 발판", bankrupt: "채무의 굴레에서 완전 해방" },
];

export const processSteps = [
  {
    no: "01",
    title: "상담 예약 · 접수",
    desc: "전화·카카오톡·상담예약으로 문의. 상황을 듣고 일정을 잡아드립니다.",
    details: [
      "전화·카카오톡·온라인 상담예약 중 편한 방법으로 문의합니다.",
      "소득·채무·재산 상황을 간단히 정리해 전달해 주시면 좋습니다.",
      "담당 변호사가 일정을 조율해 1:1 상담을 진행합니다.",
    ],
  },
  {
    no: "02",
    title: "사건 분석 · 진단",
    desc: "소득·채무·재산 구조를 정밀 분석해 최적의 방향을 진단합니다.",
    details: [
      "급여·사업소득 등 소득 구조를 확인해 가용소득을 산정합니다.",
      "담보·무담보 채무의 종류와 총액, 연체 기간을 정리합니다.",
      "개인회생·파산·채무조정 중 가장 유리한 방향을 진단합니다.",
    ],
  },
  {
    no: "03",
    title: "서류 준비 · 작성",
    desc: "신청서·변제계획안을 변호사가 직접 정교하게 작성합니다.",
    details: [
      "소득증빙·채무내역·재산목록 등 필요 서류를 안내해 드립니다.",
      "신청서와 변제계획안을 변호사가 직접 정교하게 작성합니다.",
      "청산가치·가용소득 기준에 맞춘 변제안을 설계합니다.",
    ],
  },
  {
    no: "04",
    title: "법원 접수 · 금지명령",
    desc: "법원 접수와 함께 금지·중지명령으로 추심을 신속히 멈춥니다.",
    details: [
      "관할 회생법원에 신청서를 접수합니다.",
      "접수와 동시에 금지·중지명령을 함께 신청합니다.",
      "급여·통장 압류와 추심을 신속하게 중단시킵니다.",
    ],
  },
  {
    no: "05",
    title: "개시 · 인가 결정",
    desc: "개시결정 이후 채권자 절차를 거쳐 인가 결정을 받습니다.",
    details: [
      "개시결정 이후 보정권고·채권자 이의에 대응합니다.",
      "채권자집회 및 심문 절차를 함께 진행합니다.",
      "법원의 인가결정으로 변제계획이 최종 확정됩니다.",
    ],
  },
  {
    no: "06",
    title: "성실 변제 · 면책",
    desc: "변제 완료 또는 파산 요건 충족 시 최종 면책으로 새출발합니다.",
    details: [
      "확정된 변제계획에 따라 3~5년간 성실히 변제합니다.",
      "변제 완료 시 남은 채무에 대한 면책을 신청합니다.",
      "면책 결정으로 채무의 굴레에서 벗어나 재기합니다.",
    ],
  },
];

export const successCases = [
  {
    tag: "개인회생 · 인가결정",
    title: "40대 자영업자 A님",
    debt: "1억 2,000만원",
    result: "변제 총액 대폭 감축",
    court: "수원회생법원",
    period: "약 5개월",
    desc: "매출 급감으로 누적된 카드·대출 채무. 소득 구조를 재분석해 감당 가능한 변제안으로 인가 결정을 받았습니다.",
  },
  {
    tag: "개인회생 · 면책",
    title: "30대 직장인 B님",
    debt: "8,500만원",
    result: "5년 변제 후 면책",
    court: "서울회생법원",
    period: "약 6개월",
    desc: "급여 압류 직전 상담. 압류 방어와 함께 개시결정을 이끌어내 성실 변제 후 면책까지 마무리했습니다.",
  },
  {
    tag: "개인파산 · 면책",
    title: "50대 폐업 자영업자 C님",
    debt: "2억 3,000만원",
    result: "파산·면책 결정",
    court: "수원회생법원",
    period: "약 9개월",
    desc: "사업 실패로 상환 능력을 완전히 상실한 사안. 개인파산 절차로 채무 전액에 대한 면책을 받았습니다.",
  },
  {
    tag: "개인회생 · 인가결정",
    title: "20대 사회초년생 D님",
    debt: "4,200만원",
    result: "변제금 월 부담 최소화",
    court: "수원회생법원",
    period: "약 4개월",
    desc: "사회 초년에 불어난 대출과 리볼빙. 최저생계비를 고려한 변제안으로 부담을 크게 낮췄습니다.",
  },
  {
    tag: "개인회생 · 금지명령",
    title: "40대 프리랜서 E님",
    debt: "9,700만원",
    result: "추심 즉시 중단",
    court: "서울회생법원",
    period: "약 5개월",
    desc: "금지·중지명령으로 추심을 신속히 멈추고, 변동 소득을 반영한 변제안으로 인가 결정을 받았습니다.",
  },
  {
    tag: "개인파산 · 면책",
    title: "60대 무직 F님",
    debt: "1억 5,000만원",
    result: "전액 면책 결정",
    court: "서울회생법원",
    period: "약 8개월",
    desc: "고령·무소득으로 회생이 어려운 사안. 파산 절차를 통해 채무의 굴레에서 완전히 벗어났습니다.",
  },
];

export const faqs = [
  {
    q: "개인회생 신청 자격은 어떻게 되나요?",
    a: "지속적·반복적 소득이 있고 담보채무 15억원·무담보채무 10억원 이하인 개인 채무자가 신청할 수 있습니다. 급여·사업소득뿐 아니라 아르바이트·일용직 소득도 인정될 수 있으나, 재산·소득 대비 채무 규모와 변제 가능성을 함께 검토해야 하므로 상담에서 확인이 필요합니다.",
  },
  {
    q: "개인회생과 개인파산은 어떻게 다른가요?",
    a: "개인회생은 소득이 있는 분이 3~5년간 변제 후 남은 채무를 면책받는 절차이고, 개인파산은 상환이 어려운 분이 재산을 정리하고 면책받는 절차입니다. 소득·재산·채무 구조에 따라 적합한 방향이 다릅니다.",
  },
  {
    q: "개인회생 중 통장·급여·카드를 사용할 수 있나요?",
    a: "개인회생을 진행해도 본인 명의 통장과 급여 수령은 사용할 수 있는 것이 일반적입니다. 다만 신용카드는 개시 후 사용이 제한되며, 변제계획에 따른 성실 변제가 전제됩니다. 압류된 계좌는 금지·중지명령 등으로 대응합니다.",
  },
  {
    q: "추심·급여압류를 멈출 수 있나요?",
    a: "접수와 함께 금지·중지명령을 신청하면 채권자의 추심과 급여·통장 압류 등을 신속하게 중단시킬 수 있습니다. 압류가 임박했다면 접수 시점을 앞당기는 것이 중요합니다.",
  },
  {
    q: "월 변제금은 어떻게 정해지나요?",
    a: "월 변제금은 소득에서 부양가족 수 등을 고려한 최저생계비를 제외한 가용소득을 기준으로 산정됩니다. 청산가치보다 총변제액이 많아야 하는 등 법적 기준이 적용되므로, 정확한 금액은 사건 분석 후 안내드립니다.",
  },
  {
    q: "진행 기간은 얼마나 걸리나요?",
    a: "개인회생은 접수 후 개시결정까지 통상 1~2개월, 인가결정까지 약 4~6개월이 소요됩니다. 보정권고·채권자 이의 등 사건과 관할 법원 사정에 따라 달라질 수 있습니다.",
  },
  {
    q: "서울·경기 거주자는 어느 법원에서 진행하나요?",
    a: "주소지와 사건 내용에 따라 서울회생법원, 수원회생법원 등 관할 법원에서 진행됩니다. 관할과 필요 서류는 상담에서 구체적으로 안내드립니다.",
  },
  {
    q: "가족이나 회사에 알려지나요?",
    a: "개인회생·파산 절차는 기본적으로 본인의 사건으로 진행되며, 회사 통보 없이 진행되는 것이 일반적입니다. 다만 배우자 소득 자료 등이 필요한 경우가 있어 상황별 유의사항을 상담에서 안내드립니다.",
  },
];

export const diagnosisSteps = [
  {
    short: "채무",
    title: "현재 채무 상황에 가장 가까운 항목을 선택하세요",
    options: [
      { id: "debt-burden", label: "월 소득보다 매달 갚아야 할 빚이 더 크다", weight: 2 },
      { id: "debt-rollover", label: "카드 돌려막기나 추가 대출로 빚을 막고 있다", weight: 1 },
      { id: "debt-overdue", label: "연체가 3개월 이상 이어지고 있다", weight: 2 },
      { id: "debt-living", label: "빚 때문에 생활비·월세까지 빠듯해졌다", weight: 1 },
    ],
  },
  {
    short: "소득",
    title: "현재 소득 상황에 가장 가까운 항목은?",
    options: [
      { id: "income-steady", label: "직장 급여소득이 꾸준히 들어온다", weight: 0 },
      { id: "income-variable", label: "사업·프리랜서 소득이지만 변동이 크다", weight: 1 },
      { id: "income-irregular", label: "일용직·아르바이트로 소득이 불규칙하다", weight: 1 },
      { id: "income-none", label: "현재 뚜렷한 소득이 거의 없다", weight: 2 },
    ],
  },
  {
    short: "추심",
    title: "현재 압류·추심 단계에 해당하는 항목은?",
    options: [
      { id: "seizure-salary", label: "급여나 통장이 이미 압류되었다", weight: 2 },
      { id: "seizure-asset", label: "재산에 가압류·가처분이 들어왔다", weight: 2 },
      { id: "seizure-dunning", label: "독촉 전화·문자·방문이 반복되고 있다", weight: 1 },
      { id: "seizure-none", label: "아직 압류·추심은 없고 연체만 있다", weight: 0 },
    ],
  },
];

export const repaymentGuide = {
  title: "예상 변제금",
  note: "정확한 변제금은 상담에서 산정됩니다.",
  points: [
    "소득에서 부양가족 최저생계비를 제외한 가용소득을 기준으로 산정됩니다.",
    "청산가치 이상을 변제해야 하는 등 법정 기준이 함께 적용됩니다.",
    "사건 분석 후 감당 가능한 월 변제금을 1:1로 안내해 드립니다.",
  ],
};

export const procedureGuides = {
  rehab: {
    label: "개인회생 절차",
    duration: "통상 4~6개월 내 인가",
    steps: [
      "상담 예약 · 접수",
      "사건 분석 · 진단",
      "서류 준비 · 작성",
      "법원 접수 · 금지명령",
      "개시 · 인가 결정",
      "성실 변제 · 면책",
    ],
  },
  bankrupt: {
    label: "개인파산 절차",
    duration: "통상 6개월~1년 내 면책",
    steps: [
      "상담 예약 · 접수",
      "사건 분석 · 진단",
      "서류 준비 · 작성",
      "법원 접수 · 파산선고",
      "채권자집회 · 심문",
      "면책 결정",
    ],
  },
} as const;

export const businessInfo = {
  name: "연안법무법인",
  ceo: "대표변호사 김연안 · 광고책임변호사 김연안",
  regNo: "사업자등록번호 123-45-67890",
  address: "서울특별시 서초구 서초대로 000, 연안빌딩 00층",
  phone: "02-1234-5678",
  kakao: "https://pf.kakao.com/_yeonan/chat",
};